import { AGENCY_OPTION } from "config/raven";

const AGENCY: AGENCY_OPTION = require("config/agency.json");

export const JOB_FEED_LABEL =
  AGENCY[window.location.hostname].options.jobFeedLabel || "求人フィード";

export const JOB_OFFER_LABEL =
  AGENCY[window.location.hostname].options.jobOfferLabel || "求人票";
